// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo_root__LKZRE","clickable":"Logo_clickable__S2yl5"};